export default __webpack_public_path__ + "static/media/main_item_obj_01.cbd247f6.png";